import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { PwaInstallService } from '../../../core/services/pwa-install.service';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { ButtonComponent } from '../button/button.component';
import { ModalDialogComponent } from '../modal-dialog/modal-dialog.component';

@Component({
  selector: 'app-pwa-install-modal',
  standalone: true,
  imports: [ModalDialogComponent, ButtonComponent, TranslatePipe],
  templateUrl: './pwa-install-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './pwa-install-modal.component.css',
})
export class PwaInstallModalComponent {
  protected readonly pwaInstall = inject(PwaInstallService);

  async onInstall(): Promise<void> {
    await this.pwaInstall.promptInstall();
  }

  onDefer(): void {
    this.pwaInstall.defer();
  }
}
